import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { injectIntl, IntlShape } from 'react-intl';
import SahamDrawer from 'components/SahamDrawer';
import { ContainerInDrawer } from 'containers/LawyerFeeNote/styled-components';
import { get } from 'lodash';
import { isDesactivateIntervenant } from 'services/utils';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { SagisConfig } from 'containers/AppContainer/typings';
import styled from 'styled-components';
import { Link, Typography } from '@material-ui/core';
import {
  CORRECTIONAL_JUDICIARY_PROCESS,
  MODIFIER,
} from 'containers/CourtManagerLegalProceedings/TopCard/constants';
import EditIcon from 'images/edit-logo.svg';
import { ClaimRecapType } from 'typings/claimTypes';

export interface AssignmentClaimDrawerProps {
  intl: IntlShape;
  open: boolean;
  handleToggleDrawer: Function;
  listings: any;
  judiciaryProcess: any;
  intervenants: SagisConfig[];
  claimRecap: ClaimRecapType;
  setIsAssignmentDialogOpen: Function;
  setJudiciaryProcessType: Function;
  judiciaryProcessId?: number;
  setIsReassignmentManager?: Function;
  isConsultation: Boolean;
}

const AssignmentClaimDrawer: React.FC<AssignmentClaimDrawerProps> = (
  props,
): JSX.Element => {
  interface AssignedLawyerBadgeProps {
    isActive: boolean;
  }
  const Title = styled(Typography)`
    text-align: left;
    font-weight: 500;
    font-size: small;
    padding: 2px 20px;
  `;
  const LawyerInfoContainer = styled.div`
    border-radius: 4px;
    border: 1px solid #8b8b8b;
    margin: 5px;
    margin-top: 20px;
    padding: 0px;
  `;
  const AssignmentLawyerTitle = styled.div`
    display: flex;
    justify-content: space-between;
  `;

  const AssignedLawyerBadge = styled.div<AssignedLawyerBadgeProps>`
    background-color: ${({ isActive }) => (isActive ? 'green' : 'red')};
    width: 5%;
  `;
  const civilJudiciaryProcessCourtNumber = get(
    props.judiciaryProcess?.find(
      (el: any) => el.id === props.judiciaryProcessId,
    ),
    'courtNumber',
  );

  const displayAssignedLawyers = () => {
    const lawyerAssignment = get(
      props.claimRecap,
      'claim.assignment',
      [],
    ).filter((el: any) => el.judiciaryProcessId === props.judiciaryProcessId);
    const lawyers = lawyerAssignment
      .filter((el: any) => !el.isDeleted && el.assignedLawyer)
      .map((el: any) => {
        return {
          assignedLawyer: !isDesactivateIntervenant(
            get(props.listings, 'intervenants'),
            get(el, 'assignedLawyer'),
          )
            ? getValueByCode(get(el, 'assignedLawyer'), props.intervenants)
            : getValueByCode(
                get(el, 'assignedLawyer'),
                get(props.listings, 'inactiveIntervenants', []),
              ) + ' (Inactif)',
          assignmentDate: props.intl.formatDate(
            get(el, 'lawyerAssignmentDate'),
            {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            },
          ),
        };
      });
    const deletedLawyers = lawyerAssignment
      .filter((el: any) => el.isDeleted && el.assignedLawyer)
      .map((el: any) => {
        return {
          assignedLawyer: !isDesactivateIntervenant(
            get(props.listings, 'intervenants'),
            get(el, 'assignedLawyer'),
          )
            ? getValueByCode(get(el, 'assignedLawyer'), props.intervenants)
            : getValueByCode(
                get(el, 'assignedLawyer'),
                get(props.listings, 'inactiveIntervenants', []),
              ) + ' (Inactif)',
          assignmentDate: props.intl.formatDate(
            get(el, 'lawyerAssignmentDate'),
            {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            },
          ),
          isDeleted: get(el, 'isDeleted'),
          updateDate: props.intl.formatDate(get(el, 'updatedAt'), {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }),
        };
      });
    return [...lawyers, ...deletedLawyers].map((el: any) => {
      return (
        <LawyerInfoContainer>
          {' '}
          <div style={{ display: 'flex' }}>
            <AssignedLawyerBadge isActive={!el.isDeleted} />
            <div>
              <Title gutterBottom style={{ color: '#8B8B8B' }}>
                {translate({ ...messages.assignedLawyer }, props)}
              </Title>
              <Title gutterBottom>{el.assignedLawyer}</Title>
              <div style={{ display: 'flex' }}>
                <div>
                  <Title gutterBottom style={{ color: '#8B8B8B' }}>
                    {translate({ ...messages.assignmentDate }, props)}
                  </Title>
                  <Title gutterBottom>{el.assignmentDate}</Title>
                </div>
                {el.isDeleted && (
                  <div>
                    <Title gutterBottom style={{ color: '#8B8B8B' }}>
                      {translate({ ...messages.reassignmentDate }, props)}
                    </Title>
                    <Title gutterBottom>{el.updateDate}</Title>
                  </div>
                )}
              </div>
            </div>
          </div>
        </LawyerInfoContainer>
      );
    });
  };
  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={props.handleToggleDrawer}
      title={translate({ ...messages.AssignmentLawyerClaim }, props, {
        number: null,
      })}
    >
      <ContainerInDrawer>
        <AssignmentLawyerTitle>
          <Title gutterBottom style={{ fontSize: '18px' }}>
            {civilJudiciaryProcessCourtNumber
              ? `${translate(
                  { ...messages.courtNumberTitle },
                  props,
                )} ${civilJudiciaryProcessCourtNumber}`
              : CORRECTIONAL_JUDICIARY_PROCESS}{' '}
          </Title>
          {!props.isConsultation && (
            <div
              style={{ cursor: 'pointer', padding: '0px 20px', margin: '17px' }}
            >
              <Link
                onClick={() => {
                  props.setIsAssignmentDialogOpen(true);
                  props.setIsReassignmentManager &&
                    props.setIsReassignmentManager(false);
                }}
              >
                {MODIFIER}
              </Link>
              <img
                src={EditIcon}
                style={{ marginLeft: '5px' }}
                alt="FeeNoteIcon"
              />
            </div>
          )}
        </AssignmentLawyerTitle>
        {displayAssignedLawyers()}
      </ContainerInDrawer>
    </SahamDrawer>
  );
};
export default injectIntl(AssignmentClaimDrawer);
